var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('span',_vm._g({staticClass:"red--text",attrs:{"id":"requiredMark"}},on),[_vm._v(" (※)")])]}}])},[_c('span',[_vm._v("必須入力")])])}
var staticRenderFns = []

export { render, staticRenderFns }